import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import { useCallback } from 'react';
import { openUrl } from '../../utils/urlUtils';
export const ExternalLinkMessageBoxContents = ({ url, onClose }) => {
    const onClick = useCallback(() => {
        openUrl(url);
        onClose();
    }, [url, onClose]);
    return (_jsxs(_Fragment, { children: [_jsx(DialogContentText, { children: "WARNING! You are about to open a link to an external site. We can make no guarantees about the content or safety of the site, so proceed at your own risk! Only open links to sites that you trust." }), _jsxs(DialogContentText, { children: ["Link URL:", _jsx("pre", { children: url })] }), _jsx(DialogActions, { children: _jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClick, children: "Understood, Open Link" }) })] }));
};
